'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubscriptionDeriver = function SubscriptionDeriver() {
  (0, _classCallCheck3.default)(this, SubscriptionDeriver);
};

exports.default = SubscriptionDeriver;

SubscriptionDeriver.daysRemainingInCycle = function (subscription) {
  return (0, _deep.deepExtract)('current_subscription.number_of_days_left_in_cycle', subscription);
};

SubscriptionDeriver.subscriptionNextCycleDate = function (subscription) {
  var nextCycleDate = (0, _deep.deepExtract)('current_subscription.next_cycle', subscription);
  return nextCycleDate && nextCycleDate * 1e3;
};

SubscriptionDeriver.subscriptionCycleEndDate = function (subscription) {
  return (0, _deep.deepExtract)('current_subscription.cycle_end_date', subscription);
};

SubscriptionDeriver.subscriptionMsaId = function (subscription) {
  return (0, _deep.deepExtract)('current_subscription.msa.id', subscription);
};

SubscriptionDeriver.planFromSubscription = function (subscription) {
  return (0, _deep.deepExtract)('current_subscription.plan', subscription);
};

SubscriptionDeriver.planFromUpcomingSubscription = function (subscription) {
  return (0, _deep.deepExtract)('requested_subscription.plan', subscription);
};

SubscriptionDeriver.bundlesFromSubscription = function (subscription) {
  return (0, _deep.deepExtract)('class_bundles', subscription);
};

SubscriptionDeriver.bundlesFromUpcomingSubscription = function (subscription) {
  return (0, _deep.deepExtract)('upcoming_class_bundles', subscription);
};

SubscriptionDeriver.hasTax = function (subscription) {
  return (0, _deep.deepExtract)('current_subscription.plan.tax_amount', subscription) > 0;
};

SubscriptionDeriver.isFreemium = function () {
  var subscription = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return subscription.planMode === 'trial_no_hardware';
};